import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getFundsByPan,
  getTransactionHistory,
  getTrackDetails,
  clearTransactionHistory,
} from "../../../store/actions";
import { ALL, REQ_BY } from "../../../store/types";
import { Dialog, Paper } from "@material-ui/core";
import { List } from "../transactions/nfoAndNewPurchase";
import { Debtbutton, DebtbuttonActive } from "../../forms/button";
import { NEW_TRANSACTION_URL } from "../transactions";
import { FormatCurrency } from "../../home/currencyFormatter";
import { PerformanceModal } from "../customModal";
import ReinitiateConfirm from "../transactions/ReinitiateConfirm";

class HistoryDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionList: [],
      showError: false,
      openPerformanceModal: false,
      TrackData: [],
      transaction: null,
    };
  }

  componentDidMount() {
    const { state } = this.props.location || {};
    const { isKyc } = state || {};
    this.props.clearTransactionHistory();
    if (!!isKyc) {
      this.getFunds();
    } else {
      this.setState({ showError: true });
    }
  }

  getFunds = async () => {
    const { investorData, userId } = this.props;
    const params = { invdstflg: ALL, pan: investorData.PAN, UserId: userId };

    const response = await this.props.getFundsByPan(params);
    if (response) {
      const {
        Table1: [fund],
      } = response;
      if (fund) {
        this.getTransactions(fund.Fund_Id);
      }
    }
  };

  getTransactions = async (fund) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.setState({ selectedFund: fund });
    const { investorData, userId } = this.props;
    const params = {
      Uid: userId,
      pan: investorData.PAN,
      InvdDistFlag: "A",
      Fund: fund,
    };
    const x = await this.props.getTransactionHistory(params);
  };

  closePerformanceModal = () => {
    this.setState({
      openPerformanceModal: false,
    });
  };

  gotoTrack = (item) => async () => {
    const reverseDate = !!item && !!item.td_trdt ? item.td_trdt.split("/") : "";
    const formDate = !!reverseDate
      ? `${reverseDate[1]}/${reverseDate[0]}/${reverseDate[2]}`
      : "";
    const params = {
      Fund: item.td_fund,
      Ihno: item.td_ihno,
      Status: item.Status,
      SchemeDesc: item.td_scheme,
      TrDate: formDate,
    };
    const response = await this.props.getTrackDetails(params);
    if (!!response && !!response.DtData) {
      this.setState({
        openPerformanceModal: true,
        TrackData: response.DtData,
      });
    }
  };

  async copyTransactionLink(transaction) {
    try {
      const link = transaction.Link || "";
      await navigator.clipboard.writeText(link);
      alert("Link copied to clipboard!");

      console.log("Transaction URL copied to clipboard");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  render() {
    const { state } = this.props.location || {};
    const { isKyc } = state || {};
    const { showError, selectedFund } = this.state;
    const { fundsList, transactions, investorData } = this.props;
    const transaction = this.state.transaction;
    return (
      <Paper
        className="digital-form-container"
        style={{ boxShadow: "0px 0px 2px 0px lightgray", margin: 20 }}
      >
        <PerformanceModal
          open={this.state.openPerformanceModal}
          data={this.state.TrackData}
          closeModal={this.closePerformanceModal}
        />
        {!isKyc && !!showError ? (
          <div style={{ padding: 10 }}>
            No Investor PAN found. Please submit Investor PAN
          </div>
        ) : (
          <React.Fragment>
            <div className="digital-form-left-div">
              <List investorData={investorData} />
              {fundsList?.map((fund, index) => (
                <div
                  key={index}
                  className="digital-form-investor-list"
                  style={{
                    backgroundColor:
                      fund.Fund_Id === selectedFund ? "#f3f9fd" : "#FFF",
                    cursor: "pointer",
                  }}
                  onClick={() => this.getTransactions(fund.Fund_Id)}
                >
                  <div
                    className={
                      fund.Fund_Id === selectedFund
                        ? "digital-form-main-text"
                        : ""
                    }
                  >
                    {fund.FN_FundDescription}
                  </div>
                </div>
              ))}
            </div>
            <div className="digital-form-Right-div-history">
              <div style={{ fontSize: 15, fontFamily: "OpenSans-Bold" }}>
                List of Transactions
              </div>
              {transactions.map((transaction, index) => {
                const hasLink = !!transaction.Link || !!transaction.link;

                return (
                  <React.Fragment key={index}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 5,
                      }}
                    >
                      <div className="investor-investments-container-title">
                        {transaction.SchemeDesc}
                      </div>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        {/*                       
                        {hasLink&&(transaction.Status === "Pending"  || transaction.Status ==="Pending payment confirmation")?
                        <div
                          // style={{opacity:hasLink?1:'0.4'}}
                        >
                          <Debtbutton
                          width={100}
                            title="Copy transaction link"
                            buttontitle={
                              <span>
                                <FileCopyOutlined className="d-lg-none d-inline" />
                                <span className="d-none d-lg-inline">
                                Copy Link
                                </span>
                              </span>
                            }
                            onClick={()=>this.copyTransactionLink(transaction)}
                          />
                        </div>:<div style={{width:100}}></div>}
                      */}

                        {transaction.Status === "Pending" ||
                        transaction.Status === "Pending payment confirmation" ||
                        transaction.Status === "Success" ? (
                          <div>
                            <Debtbutton
                              width={100}
                              buttontitle="Track"
                              onClick={this.gotoTrack(transaction)}
                            />
                          </div>
                        ) : (
                          <div style={{ width: 100 }}></div>
                        )}
                        {transaction.td_branch == "DA99" && (
                          <div
                            style={{
                              display:
                                !!investorData &&
                                !!investorData.PAN &&
                                investorData.PAN.charAt(3).toUpperCase() === "P"
                                  ? "flex"
                                  : "none",
                            }}
                          >
                            <Debtbutton
                              width={100}
                              buttontitle="Re-initiate"
                              onClick={() => this.setState({ transaction })}
                            />
                          </div>
                        )}
                        <DebtbuttonActive
                          width={100}
                          buttontitle="Transact"
                          onClick={() =>
                            this.props.history.push(
                              NEW_TRANSACTION_URL + "/transction-types"
                            )
                          }
                        />
                      </div>
                    </div>
                    <div>{transaction.TrtypeDesc}</div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 15,
                          fontFamily: "OpenSans-SemiBold",
                          color: "#0076cb",
                        }}
                      >
                        Amount -{" "}
                        <FormatCurrency
                          value={transaction.td_amt.split(".")[0]}
                        />
                      </div>

                      <div
                        style={{
                          fontSize: 15,
                          fontFamily: "OpenSans-SemiBold",
                          color: "#0076cb",
                        }}
                      >
                        Transaction Number - {transaction.td_trno}
                      </div>
                    </div>

                    <div className="investor-investments-sub-container">
                      <div>
                        <div className="investor-investments-text">Folio</div>
                        <div className="investor-investments-sub-text">
                          {transaction.td_acno}
                        </div>
                      </div>
                      <div>
                        <div className="investor-investments-text">NAV</div>
                        <div className="investor-investments-sub-text">
                          {/* <FormatCurrency value={transaction.td_nav} /> */}
                          {transaction.td_nav}(INR)
                        </div>
                      </div>
                      <div>
                        <div className="investor-investments-text">Units</div>
                        <div className="investor-investments-sub-text">
                          {transaction.td_units}
                        </div>
                      </div>
                      <div>
                        <div className="investor-investments-text">Date</div>
                        <div className="investor-investments-sub-text">
                          {transaction.td_trdt}
                        </div>
                      </div>
                      <div>
                        <div className="investor-investments-text">Status</div>
                        <div
                          className="investor-investments-sub-text"
                          style={{
                            color:
                              transaction.Status === "Success"
                                ? "#6fde7a"
                                : "#e37474",
                          }}
                        >
                          {transaction.Status}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </React.Fragment>
        )}

        <Dialog
          open={!!this.state.transaction}
          onClose={() => this.setState({ transaction: null })}
          PaperProps={{
            style: {
              width: "80vw",
            },
          }}
        >
          <div className="p-4">
            {!!this.state.transaction && (
              <ReinitiateConfirm
                history={this.props.history}
                transaction={this.state.transaction}
                onClose={() => this.setState({ transaction: null })}
                onConfirm={() => {
                  this.handleReInitiateTransaction(this.state.transaction);
                }}
              />
            )}
          </div>
        </Dialog>
        <div className="mobile-aum-list">
          <div className="heading heading-responsive">List of Transactions</div>
          {transactions.length > 0 ? (
            transactions.map((transaction, index) => (
              <InvestorTableCard
                key={index}
                Name={transaction.SchemeDesc}
                history={this.props.history}
                Type={transaction.TrtypeDesc}
                Ref_No={transaction.td_trno}
                Folio={transaction.td_acno}
                Units={transaction.td_units}
                Date={transaction.td_trdt}
                Status={transaction.Status}
                Amount={transaction.td_amt}
                NAV={transaction.td_nav}
                Investordata={investorData}
                transaction={transaction}
                gotoTrack={this.gotoTrack}
              />
            ))
          ) : (
            <div
              style={{
                fontFamily: "SourceSansPro-SemiBold",
                fontSize: 14,
                textAlign: "center",
                color: "red",
              }}
            >
              {" "}
              No Data Found
            </div>
          )}
        </div>
      </Paper>
    );
  }
}

export default connect(
  ({ authReducer, transactionHistory }) => {
    const { investorData, userId, beta_user } = authReducer;
    const { fundsList, transactions } = transactionHistory;
    return { investorData, userId, fundsList, transactions, beta_user };
  },
  {
    getFundsByPan,
    getTransactionHistory,
    getTrackDetails,
    clearTransactionHistory,
  }
)(HistoryDetail);
export class InvestorTableCard extends Component {
  render() {
    const {
      Type,
      Ref_No,
      Folio,
      Units,
      Date,
      Status,
      Amount,
      NAV,
      Name,
      Investordata,
      transaction,
      gotoTrack,
    } = this.props;
    return (
      <div>
        <div
          style={{
            background: "white",
            border: "1px solid rgba(211,211,211,0.3)",
            padding: "7px 10px",
            margin: "10px 0px",
          }}
        >
          <div>
            <div
              style={{
                fontFamily: "SourceSansPro-SemiBold",
                color: "#00579b",
                fontSize: 14,
                paddingBottom: 5,
                borderBottom: "1px solid rgba(211,211,211,0.3)",
              }}
            >
              {Name}
            </div>
          </div>

          <div style={{ display: "flex", padding: "8px 0px" }}>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "SourceSansPro-Regular",
                  fontSize: 12,
                  color: "#8b8b8b",
                }}
              >
                Type
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: "#293139",
                }}
              >
                {!!Type ? Type : "-"}
              </div>
            </div>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "SourceSansPro-Regular",
                  fontSize: 12,
                  color: "#8b8b8b",
                }}
              >
                Amount
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: "#00579b",
                }}
              >
                ₹{!!Amount.split(".")[0] ? Amount.split(".")[0] : "-"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", padding: "8px 0px" }}>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "SourceSansPro-Regular",
                  fontSize: 12,
                  color: "#8b8b8b",
                }}
              >
                Transaction Number
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: "#293139",
                }}
              >
                {!!Ref_No ? Ref_No : "-"}
              </div>
            </div>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "SourceSansPro-Regular",
                  fontSize: 12,
                  color: "#8b8b8b",
                }}
              >
                Folio
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: "#293139",
                }}
              >
                {!!Folio ? Folio : "-"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", padding: "8px 0px" }}>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "SourceSansPro-Regular",
                  fontSize: 12,
                  color: "#8b8b8b",
                }}
              >
                NAV
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: "#293139",
                }}
              >
                {!!NAV && NAV !== "-" ? `₹${NAV}` : "-"}
              </div>
            </div>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "SourceSansPro-Regular",
                  fontSize: 12,
                  color: "#8b8b8b",
                }}
              >
                Units
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: "#293139",
                }}
              >
                {!!Units ? Units : "-"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", padding: "8px 0px" }}>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "SourceSansPro-Regular",
                  fontSize: 12,
                  color: "#8b8b8b",
                }}
              >
                Date
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: "#293139",
                }}
              >
                {!!Date ? Date : "-"}
              </div>
            </div>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "SourceSansPro-Regular",
                  fontSize: 12,
                  color: "#8b8b8b",
                }}
              >
                Status
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: Status === "Success" ? "#34A853" : "#D0021B",
                }}
              >
                {!!Status ? Status : "-"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {Status === "Pending" ||
            Status === "Pending payment confirmation" ||
            Status === "Success" ? (
              <div>
                <Debtbutton
                  width={100}
                  buttontitle="Track"
                  onClick={gotoTrack(transaction)}
                />
              </div>
            ) : (
              <div style={{ width: 100 }}></div>
            )}
            <div
              style={{
                display:
                  !!Investordata &&
                  !!Investordata.PAN &&
                  Investordata.PAN.charAt(3).toUpperCase() === "P"
                    ? "flex"
                    : "none",
              }}
            >
              {Status === "Rejected" ? (
                <Debtbutton
                  width={100}
                  buttontitle="Re-initiate"
                  onClick={() =>
                    this.props.history.push(
                      NEW_TRANSACTION_URL + "/transction-types"
                    )
                  }
                />
              ) : (
                <DebtbuttonActive
                  width={100}
                  buttontitle="Transact"
                  onClick={() =>
                    this.props.history.push(
                      NEW_TRANSACTION_URL + "/transction-types"
                    )
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
